var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found container"},[_c('h1',[_vm._v("404 Page Not Found")]),_c('img',{staticClass:"img",attrs:{"src":require("../assets/404.png"),"alt":"404"}})])
}]

export { render, staticRenderFns }